import { useState } from "react";
import { useHttpClient } from "../../../../../../shared/hooks/http-hook";
import { useLoading } from "../../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import "./RelatorioConsultaDfes.scss";

function RelatorioConsultaDfes({
  dadosClinica,
  auth,
  showFatura,
  unidadeSelecionada = "",
}) {
  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();

  const [filtros, setFiltros] = useState({
    tipoDocumento: "",
    nrDocumento: "",
    iud: "",
  });

  const [documentos, setDocumentos] = useState([]);
  const [paginacao, setPaginacao] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  });

  const tiposDocumento = [
    { value: "", label: "Todos os tipos" },
    { value: "FTE", label: "Fatura (FTE)" },
    { value: "FRE", label: "Fatura Recibo (FRE)" },
    { value: "TVE", label: "Talão de vendas (TVE)" },
    { value: "RCE", label: "Recibo (RCE)" },
    { value: "NCE", label: "Nota de Crédito (NCE)" },
    { value: "Event", label: "Cancelamento (Event)" },
  ];

  const buscarDocumentosHandler = async (page = 1) => {
    if (!filtros.tipoDocumento && !filtros.nrDocumento && !filtros.iud) {
      toast.error("Por favor, preencha pelo menos um campo de busca");
      return;
    }

    startLoading();
    try {
      const params = new URLSearchParams();

      if (filtros.tipoDocumento) {
        params.append("tipoDocumento", filtros.tipoDocumento);
      }
      if (filtros.nrDocumento) {
        params.append("nrDocumento", filtros.nrDocumento);
      }
      if (filtros.iud) {
        params.append("iud", filtros.iud);
      }

      if (filtros.ano) {
        params.append("ano", filtros.ano);
      }

      // Vazio = consolidado da empresa.
      if (unidadeSelecionada) {
        params.append("estabelecimento", unidadeSelecionada);
      }

      // Adicionar paginação
      params.append("page", page);
      params.append("limit", paginacao.limit);

      const responseData = await sendRequest(
        `${
          process.env.REACT_APP_BACKEND_LINK
        }/api/documentoeletronico/consulta/${
          dadosClinica._id
        }?${params.toString()}`,
        "GET",
        null,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      setDocumentos(responseData.documentosEletronicos || []);
      setPaginacao({
        ...paginacao,
        ...responseData.pagination,
      });
    } catch (err) {
      console.error("Erro ao buscar documentos:", err);
    } finally {
      stopLoading();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const limparFiltros = () => {
    setFiltros({
      tipoDocumento: "",
      nrDocumento: "",
      iud: "",
      ano: new Date().getFullYear(), // Volta para ano atual
    });
    setDocumentos([]);
  };

  const formatarData = (data) => {
    if (!data) return "-";
    const date = new Date(data);
    return date.toLocaleDateString("pt-PT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="relatorio-consulta-documentos">
      <div className="filtros-busca">
        <h3>Consultar Documentos Eletrónicos</h3>

        <div className="filtros-grid">
          <div className="filtro-item">
            <label>Tipo de Documento:</label>
            <select
              name="tipoDocumento"
              value={filtros.tipoDocumento}
              onChange={handleInputChange}
            >
              {tiposDocumento.map((tipo) => (
                <option key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </option>
              ))}
            </select>
          </div>

          <div className="filtro-item">
            <label>Nº Documento:</label>
            <input
              type="text"
              name="nrDocumento"
              value={filtros.nrDocumento}
              onChange={handleInputChange}
              placeholder="Ex: 13"
            />
          </div>

          <div className="filtro-item">
            <label>Ano:</label>
            <select name="ano" value={filtros.ano} onChange={handleInputChange}>
              <option value="">Todos os anos</option>
              {Array.from(
                { length: new Date().getFullYear() - 2024 + 1 },
                (_, i) => 2024 + i
              ).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="filtro-item">
            <label>IUD (Entry Name):</label>
            <input
              type="text"
              name="iud"
              value={filtros.iud}
              onChange={handleInputChange}
              placeholder="Ex: CV1250324287507009000040300000001074185328646"
            />
          </div>
        </div>

        <div className="filtros-acoes">
          <button className="btn-buscar" onClick={buscarDocumentosHandler}>
            Buscar
          </button>
          <button className="btn-limpar" onClick={limparFiltros}>
            Limpar
          </button>
        </div>
      </div>

      {documentos.length > 0 && (
        <div className="resultados">
          <h4>{documentos.length} documento(s) encontrado(s)</h4>

          <div className="tabela-wrapper">
            <table className="tabela-documentos">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Nº Documento</th>
                  <th>Cliente</th>
                  <th>Valor</th>
                  <th>Data Emissão</th>
                  <th>Emitido Por</th>
                  <th>Status</th>
                  {/* <th>Ações</th> */}
                </tr>
              </thead>
              <tbody>
                {documentos.map((doc) => (
                  <tr key={doc._id}>
                    <td>{doc.tipoDocumento || "-"}</td>
                    <td>{doc.nrDocumento || "-"}</td>
                    <td>
                      {doc.entrada?.cliente ? (
                        <a
                          href={`/clientes/${doc.entrada.cliente._id}`}
                          className="link-cliente"
                        >
                          {doc.entrada.cliente.nome}
                        </a>
                      ) : doc.contaCorrente?.cliente ? (
                        <a
                          href={`/clientes/${doc.contaCorrente.cliente._id}`}
                          className="link-cliente"
                        >
                          {doc.contaCorrente.cliente.nome}
                        </a>
                      ) : doc.entrada?.clienteFornecedor ? (
                        doc.entrada.clienteFornecedor.nome
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {doc.valor
                        ? `${doc.valor.toFixed(2).toLocaleString("pt-Br")} CVE`
                        : "-"}
                    </td>
                    <td>
                      {formatarData(doc.authorizedDateTime || doc.created_at)}
                    </td>
                    <td>{doc.usuarioEmissor?.name || "-"}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          doc.succeeded ? "status-sucesso" : "status-erro"
                        }`}
                      >
                        {doc.succeeded ? "Sucesso" : "Erro"}
                      </span>
                      {doc.anulacao?.anulado && (
                        <span className="status-badge status-anulado">
                          Anulado
                        </span>
                      )}
                    </td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* NOVO - Controles de Paginação */}
            <div className="paginacao">
              <div className="paginacao-info">
                Mostrando {documentos.length} de {paginacao.total} documentos
                (Página {paginacao.page} de {paginacao.totalPages})
              </div>
              <div className="paginacao-controles">
                <button
                  onClick={() => buscarDocumentosHandler(1)}
                  disabled={paginacao.page === 1}
                  className="btn-paginacao"
                >
                  Primeira
                </button>
                <button
                  onClick={() => buscarDocumentosHandler(paginacao.page - 1)}
                  disabled={paginacao.page === 1}
                  className="btn-paginacao"
                >
                  Anterior
                </button>
                <span className="pagina-atual">Página {paginacao.page}</span>
                <button
                  onClick={() => buscarDocumentosHandler(paginacao.page + 1)}
                  disabled={paginacao.page === paginacao.totalPages}
                  className="btn-paginacao"
                >
                  Próxima
                </button>
                <button
                  onClick={() => buscarDocumentosHandler(paginacao.totalPages)}
                  disabled={paginacao.page === paginacao.totalPages}
                  className="btn-paginacao"
                >
                  Última
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {documentos.length === 0 &&
        filtros.tipoDocumento === "" &&
        filtros.nrDocumento === "" &&
        filtros.iud === "" && (
          <div className="mensagem-inicial">
            Utilize os filtros acima para buscar documentos eletrónicos
          </div>
        )}
    </div>
  );
}

export default RelatorioConsultaDfes;
